"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _i18n = require("@/api/i18n");
var _store = require("@/api/store");
var _MultiLangMaintainCore = _interopRequireDefault(require("@/components/i18n/MultiLangMaintainCore.vue"));
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _sourceSave = require("@/utils/i18n/sourceSave");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'MultiLangProductMaintain',
  components: {
    MultiLangMaintainCore: _MultiLangMaintainCore.default,
    Tinymce: _index.default
  },
  props: {
    productId: {
      type: Number,
      required: true
    },
    maintained: {
      type: Boolean,
      default: false
    },
    pageBizIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pageDataVersion: {
      type: Number,
      default: 0
    },
    bizType: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      productInfo: null,
      skuLastValidMap: {},
      skuAttrHeaderDraftMap: {},
      editorToolbar: ['undo redo | formatselect | bold italic underline strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | link image media | removeformat code']
    };
  },
  methods: {
    asSourceSlot: function asSourceSlot(slotProps) {
      return _objectSpread(_objectSpread({}, slotProps), {}, {
        activeLangCode: slotProps.sourceLangCode,
        getCurrentValue: function getCurrentValue(fieldKey) {
          return slotProps.getSourceValue({
            fieldKey: fieldKey
          });
        },
        setCurrentValue: slotProps.setSourceValue,
        currentLangName: slotProps.defaultLangName
      });
    },
    isRichTextField: function isRichTextField(fieldKey) {
      return fieldKey === 'description.content';
    },
    isSkuValueField: function isSkuValueField(fieldKey) {
      return /^sku\.\d+\.suk$/.test(String(fieldKey || ''));
    },
    isSkuAttrNameField: function isSkuAttrNameField(fieldKey) {
      return String(fieldKey || '').indexOf('sku.attrName.') === 0;
    },
    isSkuField: function isSkuField(fieldKey) {
      return this.isSkuValueField(fieldKey) || this.isSkuAttrNameField(fieldKey);
    },
    getNormalFormFieldItems: function getNormalFormFieldItems() {
      var _this = this;
      var fieldItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return fieldItems.filter(function (item) {
        return !_this.isRichTextField(item.fieldKey) && !_this.isSkuField(item.fieldKey);
      });
    },
    getSkuAttrNameFieldItems: function getSkuAttrNameFieldItems() {
      var _this2 = this;
      var fieldItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var list = fieldItems.filter(function (item) {
        return _this2.isSkuAttrNameField(item.fieldKey);
      }).map(function (item) {
        var parts = String(item.fieldKey || '').split('.');
        var attrId = parts.length > 2 ? parts[2] : '-';
        var maybeIndex = Number(attrId);
        return _objectSpread(_objectSpread({}, item), {}, {
          attrId: attrId,
          attrIndex: Number.isNaN(maybeIndex) ? 0 : maybeIndex
        });
      }).sort(function (a, b) {
        return a.attrIndex - b.attrIndex;
      });
      return list.map(function (item, index) {
        return _objectSpread(_objectSpread({}, item), {}, {
          attrIndex: index
        });
      });
    },
    getSkuValueFieldItems: function getSkuValueFieldItems() {
      var _this3 = this;
      var fieldItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return fieldItems.filter(function (item) {
        return _this3.isSkuValueField(item.fieldKey);
      }).map(function (item) {
        var parts = String(item.fieldKey || '').split('.');
        var skuId = parts.length > 1 ? parts[1] : '-';
        var skuNum = Number(skuId);
        return _objectSpread(_objectSpread({}, item), {}, {
          skuId: skuId,
          skuNum: Number.isNaN(skuNum) ? 0 : skuNum
        });
      }).sort(function (a, b) {
        return a.skuNum - b.skuNum;
      });
    },
    getSkuAttrHeaderDraftKey: function getSkuAttrHeaderDraftKey(column, slotProps) {
      return "".concat(column.fieldKey, "__").concat(slotProps.activeLangCode || '');
    },
    getSkuAttrHeaderDraftValue: function getSkuAttrHeaderDraftValue(column, slotProps) {
      var key = this.getSkuAttrHeaderDraftKey(column, slotProps);
      if (this.skuAttrHeaderDraftMap[key] !== undefined) {
        return this.skuAttrHeaderDraftMap[key];
      }
      var current = slotProps.getCurrentValue(column.fieldKey);
      var source = slotProps.getSourceValue(column) || '';
      var initial = current !== undefined && current !== null && String(current).length > 0 ? current : source;
      this.$set(this.skuAttrHeaderDraftMap, key, initial);
      return initial;
    },
    handleSkuAttrHeaderDraftInput: function handleSkuAttrHeaderDraftInput(column, slotProps, value) {
      var key = this.getSkuAttrHeaderDraftKey(column, slotProps);
      this.$set(this.skuAttrHeaderDraftMap, key, value);
    },
    commitSkuAttrHeaderDraft: function commitSkuAttrHeaderDraft(column, slotProps) {
      var key = this.getSkuAttrHeaderDraftKey(column, slotProps);
      var value = this.skuAttrHeaderDraftMap[key];
      slotProps.setCurrentValue(column.fieldKey, value === undefined || value === null ? '' : value);
    },
    splitSkuTokens: function splitSkuTokens(value) {
      var val = String(value || '');
      return val.split(/[,，/|]/);
    },
    splitSkuSeparators: function splitSkuSeparators(value) {
      var val = String(value || '');
      return val.match(/[,，/|]/g) || [];
    },
    joinSkuTokens: function joinSkuTokens(tokens, separators) {
      var result = [];
      for (var i = 0; i < tokens.length; i++) {
        result.push(tokens[i] || '');
        if (i < separators.length) {
          result.push(separators[i]);
        }
      }
      return result.join('');
    },
    getSkuSegmentByIndex: function getSkuSegmentByIndex(row, index, slotProps) {
      var preferCurrent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var sourceRaw = slotProps.getSourceValue(row) || '';
      var currentRaw = slotProps.getCurrentValue(row.fieldKey);
      var hasCurrentRaw = currentRaw !== undefined && currentRaw !== null;
      var baseRaw = preferCurrent ? hasCurrentRaw ? String(currentRaw) : sourceRaw : sourceRaw;
      var tokens = this.splitSkuTokens(baseRaw);
      return tokens[index] || '';
    },
    handleSkuSegmentInput: function handleSkuSegmentInput(row, index, value, slotProps) {
      var sourceRaw = slotProps.getSourceValue(row);
      var sourceTokens = this.splitSkuTokens(sourceRaw);
      var separators = this.splitSkuSeparators(sourceRaw);
      var currentRaw = slotProps.getCurrentValue(row.fieldKey);
      var baseRaw = currentRaw !== undefined && currentRaw !== null ? String(currentRaw) : sourceRaw;
      var tokens = this.splitSkuTokens(baseRaw);
      var targetLength = sourceTokens.length;
      while (tokens.length < targetLength) {
        tokens.push(sourceTokens[tokens.length] || '');
      }
      tokens[index] = value;
      var merged = this.joinSkuTokens(tokens.slice(0, targetLength), separators);
      slotProps.setCurrentValue(row.fieldKey, merged);
    },
    getRichFieldItems: function getRichFieldItems() {
      var _this4 = this;
      var fieldItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return fieldItems.filter(function (item) {
        return _this4.isRichTextField(item.fieldKey);
      });
    },
    getEditorId: function getEditorId(fieldKey, activeLangCode) {
      return "i18n-editor-product-".concat(this.productId, "-").concat(String(fieldKey).replace(/\./g, '-'), "-").concat(activeLangCode);
    },
    getEditorKey: function getEditorKey(fieldKey, activeLangCode) {
      return "product__".concat(this.productId, "__").concat(fieldKey, "__").concat(activeLangCode);
    },
    showEditor: function showEditor(slotProps) {
      return !slotProps.loading && !!slotProps.activeLangCode;
    },
    loadDetail: function () {
      var _loadDetail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(productId) {
        var _yield$Promise$all, _yield$Promise$all2, productInfo, contentJson, fieldItems, translations;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([(0, _store.productDetailApi)(productId), (0, _i18n.i18nBizContentApi)({
                bizType: 'PRODUCT',
                bizId: productId
              })]);
            case 2:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              productInfo = _yield$Promise$all2[0];
              contentJson = _yield$Promise$all2[1];
              this.productInfo = productInfo;
              fieldItems = this.buildFieldItems(productInfo);
              translations = this.buildBaseTranslations(fieldItems);
              this.mergeSavedTranslations(translations, contentJson);
              this.fillSkuAttrNameTranslationDefaults(fieldItems, translations);
              return _context.abrupt("return", {
                bizType: 'PRODUCT',
                bizId: productId,
                fieldItems: fieldItems,
                translations: translations,
                sourceDetail: productInfo
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadDetail(_x) {
        return _loadDetail.apply(this, arguments);
      }
      return loadDetail;
    }(),
    buildFieldItems: function buildFieldItems() {
      var productInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var fieldItems = [{
        fieldKey: 'product.storeName',
        fieldLabel: '商品名称',
        fieldGroup: '商品表',
        sourceValue: productInfo.storeName || ''
      }, {
        fieldKey: 'product.keyword',
        fieldLabel: '商品关键字',
        fieldGroup: '商品表',
        sourceValue: productInfo.keyword || ''
      }, {
        fieldKey: 'product.storeInfo',
        fieldLabel: '商品简介',
        fieldGroup: '商品表',
        sourceValue: productInfo.storeInfo || ''
      }, {
        fieldKey: 'product.unitName',
        fieldLabel: '单位',
        fieldGroup: '商品表',
        sourceValue: productInfo.unitName || ''
      }, {
        fieldKey: 'description.content',
        fieldLabel: '商品详情',
        fieldGroup: '商品详情表',
        sourceValue: productInfo.content || ''
      }];
      var attrValueList = Array.isArray(productInfo.attrValue) ? productInfo.attrValue : [];
      attrValueList.forEach(function (item) {
        fieldItems.push({
          fieldKey: "sku.".concat(item.id, ".suk"),
          fieldLabel: "\u89C4\u683C\u503C(".concat(item.id, ")"),
          fieldGroup: '商品规格表',
          sourceValue: item.suk || ''
        });
      });
      var attrList = Array.isArray(productInfo.attr) ? productInfo.attr : Array.isArray(productInfo.productAttr) ? productInfo.productAttr : [];
      attrList.forEach(function (item, index) {
        var attrId = item && item.id !== undefined && item.id !== null ? item.id : index;
        fieldItems.push({
          fieldKey: "sku.attrName.".concat(attrId),
          fieldLabel: "\u89C4\u683C\u540D(".concat(attrId, ")"),
          fieldGroup: '商品规格表',
          sourceValue: item.attrName || ''
        });
      });
      return fieldItems;
    },
    buildBaseTranslations: function buildBaseTranslations() {
      var fieldItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var translations = {};
      fieldItems.forEach(function (item) {
        translations[item.fieldKey] = {
          'zh-CN': item.sourceValue || ''
        };
      });
      return translations;
    },
    mergeSavedTranslations: function mergeSavedTranslations(translations, contentJson) {
      if (!contentJson) return;
      var saved = {};
      if (typeof contentJson === 'string') {
        try {
          saved = JSON.parse(contentJson);
        } catch (e) {
          saved = {};
        }
      } else if (_typeof(contentJson) === 'object') {
        saved = contentJson || {};
      }
      Object.keys(saved || {}).forEach(function (fieldKey) {
        if (!translations[fieldKey]) {
          translations[fieldKey] = {};
        }
        if (saved[fieldKey] && _typeof(saved[fieldKey]) === 'object') {
          Object.keys(saved[fieldKey]).forEach(function (langCode) {
            translations[fieldKey][langCode] = saved[fieldKey][langCode];
          });
        }
      });
    },
    fillSkuAttrNameTranslationDefaults: function fillSkuAttrNameTranslationDefaults() {
      var _this5 = this;
      var fieldItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var translations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var targetLangCodes = ['it-IT'];
      fieldItems.forEach(function (item) {
        if (!_this5.isSkuAttrNameField(item.fieldKey)) return;
        if (!translations[item.fieldKey]) {
          _this5.$set(translations, item.fieldKey, {});
        }
        targetLangCodes.forEach(function (langCode) {
          var currentVal = translations[item.fieldKey][langCode];
          if (currentVal === undefined || currentVal === null || String(currentVal) === '') {
            _this5.$set(translations[item.fieldKey], langCode, item.sourceValue || '');
          }
        });
      });
    },
    getSkuFormatMeta: function getSkuFormatMeta(value) {
      var val = String(value || '');
      var separatorMatches = val.match(/[,，/|]/g) || [];
      var tokens = val.split(/[,，/|]/);
      var tokenCount = tokens.length;
      var hasEmptyToken = tokens.some(function (token) {
        return token.trim().length === 0;
      });
      return {
        separatorMatches: separatorMatches,
        tokenCount: tokenCount,
        hasEmptyToken: hasEmptyToken
      };
    },
    isSkuFormatMatched: function isSkuFormatMatched(sourceValue, targetValue) {
      var sourceMeta = this.getSkuFormatMeta(sourceValue);
      var targetMeta = this.getSkuFormatMeta(targetValue);
      if (sourceMeta.hasEmptyToken || targetMeta.hasEmptyToken) return false;
      if (sourceMeta.tokenCount !== targetMeta.tokenCount) return false;
      if (sourceMeta.separatorMatches.length !== targetMeta.separatorMatches.length) return false;
      for (var i = 0; i < sourceMeta.separatorMatches.length; i++) {
        if (sourceMeta.separatorMatches[i] !== targetMeta.separatorMatches[i]) return false;
      }
      return true;
    },
    getSkuCacheKey: function getSkuCacheKey(fieldKey, langCode) {
      return "".concat(fieldKey, "__").concat(langCode);
    },
    handleSkuFocus: function handleSkuFocus(row, slotProps) {
      var key = this.getSkuCacheKey(row.fieldKey, slotProps.activeLangCode);
      this.$set(this.skuLastValidMap, key, slotProps.getCurrentValue(row.fieldKey) || '');
    },
    handleSkuBlur: function handleSkuBlur(row, slotProps) {
      var key = this.getSkuCacheKey(row.fieldKey, slotProps.activeLangCode);
      var currentValue = slotProps.getCurrentValue(row.fieldKey);
      this.$set(this.skuLastValidMap, key, currentValue || '');
    },
    beforeSave: function beforeSave(ctx) {
      var _this6 = this;
      var skuFields = (ctx.fieldItems || []).filter(function (item) {
        return _this6.isSkuValueField(item.fieldKey);
      });
      for (var i = 0; i < skuFields.length; i++) {
        var row = skuFields[i];
        var sourceValue = ctx.getSourceValue(row);
        for (var j = 0; j < ctx.editableLanguageList.length; j++) {
          var lang = ctx.editableLanguageList[j];
          var value = ctx.translations[row.fieldKey] ? ctx.translations[row.fieldKey][lang.langCode] : '';
          if (!value) continue;
          if (!this.isSkuFormatMatched(sourceValue, value)) {
            this.$message.error("SKU\u683C\u5F0F\u4E0D\u6B63\u786E\uFF0C\u9700\u4E0E\u6E90\u503C\u4FDD\u6301\u4E00\u81F4\uFF1A".concat(sourceValue || ''));
            ctx.setActiveLangCode(lang.langCode);
            return false;
          }
        }
      }
      return true;
    },
    saveSource: function () {
      var _saveSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(ctx) {
        var merged, payload;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.productInfo) {
                _context2.next = 2;
                break;
              }
              throw new Error('商品数据未加载');
            case 2:
              merged = (0, _sourceSave.applyProductSourceTranslations)(this.productInfo, ctx.translations, ctx.sourceLangCode);
              payload = (0, _sourceSave.buildProductUpdatePayload)(merged, this.bizType);
              _context2.next = 6;
              return (0, _store.productUpdateApi)(payload);
            case 6:
              this.productInfo = merged;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function saveSource(_x2) {
        return _saveSource.apply(this, arguments);
      }
      return saveSource;
    }()
  }
};